import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Registering necessary components in Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
// generateChartOptions.js
export const generateChartOptions = (additionalData) => {
    return {
      responsive: true,
      maintainAspectRatio: false,
       plugins: {
        legend: { position: 'top', display: false },
        tooltip: {
          enabled: true,
          callbacks: {
            title: (tooltipItem) => `Date: ${tooltipItem[0].label}`,
            label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
            afterLabel: (tooltipItem) => {
              // Use the additionalData that was passed to the options
              const additionalValue = additionalData[tooltipItem.dataIndex];
              return `Lab number: ${additionalValue}`; // Access additional data
            },
          },
        },
        datalabels: {
          color: '#fff',
          align: 'bottom',
          anchor: 'end',
        },
      },
      scales: {
        x: { 
          beginAtZero: false,
         },
        y: { beginAtZero: false },
      },
      layout: {
        padding: {
          top: 35,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    };
  };